import React from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";
import CustomDatePicker from "../../../../../components/Custom-Datepicker";

const AttendanceBookStatementFilter = ({
  formData,
  handleChange,
  // handleDropDownChange,
  handleGetData,
  filterFormData,
  handleReset,
  // jobtitleopts,
  // statusopts,
  // hropts,
  // sourceopts,
  // skillsopts,
}) => {
  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  // console.log("===>FormData", formData);
  console.log("===>filterFormData", filterFormData);

  const customStyle = {
    // for control
    control: (provided, state) => ({
      ...provided,
      height: "70px",
      overflow: "scroll",
    }),
    //for common cross icon
    multiValueRemove: (base, state) => ({
      ...base,
      color: "white",
      ":hover": {
        backgroundColor: "#22ACD3",
        color: "white",
      },
    }),
    //for  dropdown icon
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: "0px",
    }),
    //for dropdown conatiner
    indicatorsContainer: (provided, state) => ({
      ...provided,
      width: "28px",
      height: "34px",
      marginTop: "9px",
    }),
  };

  return (
    <div
      className="dropdown-menu custom-dropdown-width"
      aria-labelledby="excel-btn"
      // onClick={(e) => e.stopPropagation()}
    >
      <div className="container">
        <div className="row">
          <form onClick={stopPropagation}>
            <div className="row">
              {formData.map((ele, index) => (
                <div className="col-md-4 mt-1" key={index}>
                  <Form.Group className="">
                    <Form.Label className="mb-0">{ele?.name}</Form.Label>
                    {ele?.type === "Select" ? (
                      <Select
                        options={[
                          // { value: '0', label: "Select..." },
                          ...ele?.options,
                        ]}
                        value={ele?.options?.find(
                          (option) =>
                            option.value ===
                            (filterFormData?.find(
                              (item) => item.label === ele?.name
                            )?.value || null)
                        )||null}
                        name="jobTitle"
                        placeholder={ele?.placeholderText || ele?.name}
                        // value={formData.jobTitle}
                        onChange={(e) => handleChange(e, ele?.name)}
                      />
                    ) : ele?.type === "Date" ? (
                      <CustomDatePicker
                        // handleChange={handleVsaEndDate}
                        // value={formData1.Vsa_End_Date}
                        handleChange={(e) =>
                          handleChange(e.target.value, ele?.name)
                        }
                        showYearDropdown
                        dropdownMode="select"
                        name="Vsa_End_Date"
                        id="VsaEndDate"
                        className="form-control"
                        placeholderText="DD-MM-YYYY"
                        // maxDate={new Date()}
                        value={
                          (filterFormData || []).find(
                            (o) => o.label === ele?.name
                          )
                            ? (filterFormData || []).find(
                                (o) => o.label === ele?.name
                              )?.value
                            : null
                        }
                      />
                    ) : ele?.type === "Text" ? (
                      <Form.Control
                        type="text"
                        name="candidateName"
                        // value={formData.candidateName}
                        onChange={(e) =>
                          handleChange(e.target.value, ele?.name)
                        }
                      />
                    ) : ele?.type === "Number" ? (
                      <Form.Control
                        type="number"
                        name="candidateName"
                        // value={formData.candidateName}
                        // onChange={(e) => handleChange(e)}

                        onChange={(e) =>
                          handleChange(e.target.value, ele?.name)
                        }
                      />
                    ) : ele?.type === "IsMulti" ? (
                      <Select
                      options={[
                        ...ele?.options,
                      ]}
                      value={ele?.options?.filter((option) =>
                        filterFormData
                          ?.find((item) => item.label === ele?.name)
                          ?.value?.includes(option.value)
                      )}
                      name="jobTitle"
                      placeholder={ele?.placeholderText || ele?.name}
                      isMulti
                      onChange={(selectedOptions) =>
                        handleChange(
                          selectedOptions.map((option) => option.value),
                          ele?.name
                        )
                      }
                    styles={customStyle}
                    />
                    ) : null}
                  </Form.Group>
                </div>
              ))}
            </div>

            {/* Uncomment and update the code below as needed */}
          </form>

          {/* Uncomment and update the code below as needed */}
          <div className="row mt-4">
            <div className="text-end">
                <button className="custom-btn me-2" onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    handleReset();
  }} type="button">
               Reset
              </button> 
              <button
                className="custom-btn"
                onClick={() => handleGetData()}
                type="button"
              >
                Get data
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceBookStatementFilter;
